import { Lock, Mail, Phone } from "lucide-react";
import { DebouncedInput } from "../../components/DebouncedInput";
import { useState } from "react";
import { useFindPassword } from "../../hooks/auth/useFindPassword";
import { useResetPasswordData } from "../../store/authStore";
import logo from "../../images/aivy_logo3.png";

const ResetPassword = () => {
  const resetPasswordData = useResetPasswordData();
  console.log(resetPasswordData);
  const { resetPassword, isLoading, error } = useFindPassword();
  const [id, setId] = useState(resetPasswordData?.verifiedId || "");
  const [phoneNumber, setPhoneNumber] = useState(resetPasswordData?.verifiedPhone || "");
  const [newPassword, setNewPassword] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const success = await resetPassword(id, phoneNumber, newPassword);

    if (success) {
      alert("비밀번호가 성공적으로 변경되었습니다.");
      window.location.href = "/auth/signin";
    }
  };

  const formatPhoneNumber = (value: string) => {
    const numbers = value.replace(/[^\d]/g, "");
    if (numbers.length <= 3) return numbers;
    if (numbers.length <= 7)
      return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(
      7,
      11
    )}`;
  };

  const handlePhoneNumberChange = (value: string) => {
    const formatted = formatPhoneNumber(value);
    setPhoneNumber(formatted);
  };

  const handleNavigation = (path: string): void => {
    window.location.href = path;
  };

  return (
    <div className="flex flex-col min-h-screen items-center justify-center font-serif-kr">
      <div className="flex items-center justify-center gap-2">
        <img src={logo} alt="Aivy Logo" className="w-20 h-20" />
        <button
          onClick={() => handleNavigation("/")}
          className="h-12 text-4xl font-bold bg-gradient-to-r from-teal-600/60 via-green-500 to-emerald-600/60 bg-clip-text text-transparent font-serif-en"
        >
          Aivy AI
        </button>
      </div>
      <div className="w-full max-w-md px-4 space-y-8">
        <div className="space-y-2 text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900">비밀번호 재설정</h1>
          <p className="text-sm md:text-base text-gray-500">
            새로운 비밀번호를 입력해주세요.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <Mail className="h-5 w-5 text-gray-400" />
              </div>
              <DebouncedInput
                type="text"
                placeholder="아이디를 입력하세요"
                value={id}
                onChange={setId}
                className="pl-12"
                delay={300}
                disabled={true}
              />
            </div>
          </div>

          <div className="space-y-2">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <Phone className="h-5 w-5 text-gray-400" />
              </div>
              <DebouncedInput
                type="tel"
                placeholder="휴대폰 번호 (예: 010-0000-0000)"
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                maxLength={13}
                className="pl-12"
                delay={300}
                disabled={true}
              />
            </div>
          </div>

          <div className="space-y-2">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <Lock className="h-5 w-5 text-gray-400" />
              </div>
              <DebouncedInput
                type="password"
                placeholder="새로운 비밀번호를 입력하세요"
                value={newPassword}
                className="pl-12"
                onChange={setNewPassword}
                delay={300}
              />
            </div>
          </div>

          {error && (
            <div className="rounded-lg bg-red-50 p-3 text-sm text-red-600 text-left">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={!id || phoneNumber.length < 13 || !newPassword || isLoading}
            className="w-full rounded-lg bg-gradient-to-r from-teal-600/70 via-green-500/90 to-emerald-600/50 px-4 py-2 text-white text-sm md:text-base transition-all hover:shadow-lg transform hover:scale-105 duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? "처리중..." : "비밀번호 변경"}
          </button>
        </form>

        <div className="text-center text-sm md:text-base">
          <a
            href="/auth/signin"
            className="text-blue-500 hover:text-blue-600 transition-colors"
          >
            로그인으로 돌아가기
          </a>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
